import { AdminPaymentDispute } from '../../services/paymentsApi';

interface ChargebackBannerProps {
  disputes: AdminPaymentDispute[];
}

const OPEN_STATUSES = new Set(['warning_needs_response', 'needs_response', 'under_review', 'warning_under_review']);

/**
 * Spec 052 AC-42 — a gateway chargeback on the payment. Rendered only when at least one
 * dispute exists. Deliberately distinct from the DISPUTED order-status chip: this is the
 * card network clawing money back, not a customer complaint inside the order journey.
 */
export default function ChargebackBanner({ disputes }: ChargebackBannerProps) {
  if (disputes.length === 0) return null;

  const open = disputes.filter((d) => OPEN_STATUSES.has(d.status));
  const latest = disputes[0];
  const dueBy = open.find((d) => d.evidenceDueBy)?.evidenceDueBy ?? null;

  return (
    <div className="chargeback-banner" role="alert" data-testid="chargeback-banner">
      <div className="chargeback-banner-title">
        <span aria-hidden="true">⚠</span>
        {open.length > 0
          ? `Chargeback open on this payment (${open.length} of ${disputes.length})`
          : `Chargeback recorded on this payment — ${latest.status.replace(/_/g, ' ')}`}
      </div>
      <div className="chargeback-banner-body">
        {latest.amount.toFixed(2)} {latest.currency} · {latest.provider} · {latest.reason ?? 'no reason given'}
        {dueBy && <> · evidence due {new Date(dueBy).toLocaleString()}</>}
        <span className="chargeback-banner-ref">{latest.gatewayDisputeId}</span>
      </div>
      <div className="chargeback-banner-note">
        The order status is unaffected — respond to the dispute in the {latest.provider} dashboard.
      </div>
    </div>
  );
}
